import React from 'react';
import MainMenuComponent from '../../Components/Menus/MainMenuComponent';

function ManagementAssetsPage() {
  return <MainMenuComponent menuName="assets" />;
}

export default ManagementAssetsPage;
